let language = {
    DETAIL_ADD_ERROR: "The product supports purchase quantities {{minQty}} to ",
    DETAIL_ADD_TITLE:"Add to cart",
    DETAIL_WEBSIT_ADD_TITLE:"Add to {{appName}} cart",
    DETAIL_ADD_STORE_TITLE:"Add To Store",
}

export { language }